import produce from 'immer'

export const omit = <O, K extends keyof O>(o: O, k: K[]): Omit<O, K> =>
  produce(o, (draft) => {
    k.map((x) => delete draft[x as any])
  })
